import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "w-full flex flex-col items-center justify-center gap-4 py-16 text-center",
  "data-testid": "check-validation-empty-state"
}
const _hoisted_2 = { class: "flex items-center justify-center w-16 h-16 rounded-full bg-gray-50" }
const _hoisted_3 = {
  class: "w-9 h-9 text-neutral50",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = { class: "font-bold text-textPrimary" }
const _hoisted_7 = { class: "text-sm text-gray-500 max-w-md" }

import { mdiImageSearchOutline } from '@mdi/js'

import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'

import { EMPTY_STATE_TITLE } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckValidationEmptyState',
  props: {
    hasFilters: { type: Boolean }
  },
  emits: ["clearFilters"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        _createElementVNode("path", {
          d: _unref(mdiImageSearchOutline),
          fill: "currentColor"
        }, null, 8, _hoisted_4)
      ]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(EMPTY_STATE_TITLE)), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.hasFilters
            ? 'Ajuste ou limpe os filtros aplicados para ver mais registros.'
            : 'Registros lançados manualmente no painel entram aqui assim que são enviados para análise.'), 1)
    ]),
    (_ctx.hasFilters)
      ? (_openBlock(), _createBlock(GhostButton, {
          key: 0,
          text: "Limpar filtros",
          width: "180px",
          "data-testid": "check-validation-empty-clear-filters-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clearFilters')))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})